"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Wishlist = exports.InfoWrap = exports.LinkWrap = void 0;
const app_1 = require("@obvio/app");
const WishlistButton_1 = require("../../WishlistButton");
exports.LinkWrap = (0, app_1.styled)(app_1.Link) `
  display: block;
  height: 90%;
  max-width: 100%;
`;
exports.InfoWrap = app_1.styled.div `
  display: flex;
  justify-content: space-between;
  align-items: center;
  top: 100%;
  width: 100%;
`;
exports.Wishlist = (0, app_1.styled)(WishlistButton_1.WishlistButton) `
  position: static;
  border: none;
`;
